<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Data Analysis/ Sale ລາຍງານທຽບໃສ່ແຜນ
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" >

        <b-tab-item label="ລາຍງານການຂາຍ ທັງໝົດ">
          <div class="columns">
            <div class="column">
              <b-field label="ລາຍງານການຂາຍ ທັງໝົດ">
                <table width="100%" class="table ">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">
                        #
                      </th>
                      <th class="has-text-centered " width="20%">
                        ແຂວງຜະລິດ
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈຳນວນລາຍການ<br>Pre-Order
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈຳນວນເງິນ<br>Pre-Order
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈຳນວນລາຍການ<br>Online Order
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈຳນວນເງິນ<br>Online Order
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in reportDetailList"
                      :key="data.ID"
                    >
                      <td
                        class="has-text-centered"
                      >
                        {{ index + 1 }}
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        {{data.PROVINCENAME}}
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        {{data.PREORDER}}
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        {{data.PREORDERMONEY}}
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        {{data.ONLINEORDER}}
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        {{data.ONLINEORDERMONEY}}
                      </td>
              
                    </tr>
                  </tbody>
                </table>
              </b-field>
              

            </div>
          </div>
          
        </b-tab-item>
        <b-tab-item label="ລາຍງານ ທຽບໃສ່ ແຜນປະຈຳປີ">
          <div class="columns">
            <div class="column">
              <b-field label="ເລືອກປີ">
                <Multiselect
                  placeholder="ເລືອກ"
                  v-model.trim="selectedYear"
                  label="YEAR"
                  track-by="YEAR"
                  :options="yearList"
                  @input="onSelectedYear"
                >
                </Multiselect>
              </b-field>
            </div>
            <div class="column"></div>
            <div class="column"></div>
            <div class="column"></div>
            <div class="column"></div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field :label="compareLabel"> 
                <table width="100%" class="table ">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">
                        #
                      </th>
                      <th class="has-text-centered " width="10%">
                        ແຂວງຜະລິດ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນລາຍການ Pre-Order<br>
                            ແຜນ : ລາຍງານ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນເງິນ Pre-Order<br>
                            ແຜນ : ລາຍງານ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນລາຍການ Online Order<br>
                            ແຜນ : ລາຍງານ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນເງິນ Online Order<br>
                            ແຜນ : ລາຍງານ
                      </th>

                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in compareList"
                      :key="data.PROVINCEID"
                    >
                      <td
                        class="has-text-centered"
                      >
                        {{ index + 1 }}
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        {{data.PROVINCENAME}}
                      </td>
                      <td
                        class="has-text-centered"
                      >
                       
                        <span v-if="data.PREORDER/data.PREORDER_PLAN >=1"
                          class="statusLabel-passed">
                          {{ data.PREORDER_PLAN  | formatNumberLocal}} : {{data.PREORDER | formatNumberLocal}} = {{ (data.PREORDER/data.PREORDER_PLAN*100).toFixed(2) }}%
                        </span>

                        <span v-else-if="data.PREORDER/data.PREORDER_PLAN >=0.50"
                          class="statusLabel-yellow">
                          {{ data.PREORDER_PLAN  | formatNumberLocal}} : {{data.PREORDER | formatNumberLocal}}  = {{ (data.PREORDER/data.PREORDER_PLAN*100).toFixed(2) }}%
                        </span>

                        <span v-else-if="data.PREORDER/data.PREORDER_PLAN >= 0.10"
                        class="statusLabel-organge">
                        {{ data.PREORDER_PLAN  | formatNumberLocal}} : {{data.PREORDER | formatNumberLocal}} = {{ (data.PREORDER/data.PREORDER_PLAN*100).toFixed(2) }}% 
                        </span>

                        <span v-else-if="data.PREORDER/data.PREORDER_PLAN >= 0"
                          class="statusLabel-black">
                          {{ data.PREORDER_PLAN  | formatNumberLocal}} : {{data.PREORDER | formatNumberLocal}} = {{ (data.PREORDER/data.PREORDER_PLAN*100).toFixed(2) }}% 
                        </span>
                        
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        <span v-if="data.PREORDERMONEY/data.PREORDERMONEY_PLAN >=1"
                          class="statusLabel-passed">
                          {{ data.PREORDERMONEY_PLAN  | formatNumberLocal}} : {{data.PREORDERMONEY | formatNumberLocal}} = {{ (data.PREORDERMONEY/data.PREORDERMONEY_PLAN*100).toFixed(2) }}%
                        </span>

                        <span v-else-if="data.PREORDERMONEY/data.PREORDERMONEY_PLAN >=0.50"
                          class="statusLabel-yellow">
                          {{ data.PREORDERMONEY_PLAN  | formatNumberLocal}} : {{data.PREORDERMONEY | formatNumberLocal}}  = {{ (data.PREORDERMONEY/data.PREORDERMONEY_PLAN*100).toFixed(2) }}%
                        </span>

                        <span v-else-if="data.PREORDERMONEY/data.PREORDERMONEY_PLAN >= 0.10"
                        class="statusLabel-organge">
                        {{ data.PREORDERMONEY_PLAN  | formatNumberLocal}} : {{data.PREORDERMONEY | formatNumberLocal}} = {{ (data.PREORDERMONEY/data.PREORDERMONEY_PLAN*100).toFixed(2) }}% 
                        </span>

                        <span v-else-if="data.PREORDERMONEY/data.PREORDERMONEY_PLAN >= 0"
                          class="statusLabel-black">
                          {{ data.PREORDERMONEY_PLAN  | formatNumberLocal}} : {{data.PREORDERMONEY | formatNumberLocal}} = {{ (data.PREORDERMONEY/data.PREORDERMONEY_PLAN*100).toFixed(2) }}% 
                        </span>
                        
                      </td>

                      <td
                        class="has-text-centered"
                      >
                      <span v-if="data.ONLINEORDER/data.ONLINEORDER_PLAN >=1"
                          class="statusLabel-passed">
                          {{ data.ONLINEORDER_PLAN  | formatNumberLocal}} : {{data.ONLINEORDER | formatNumberLocal}} = {{ (data.ONLINEORDER/data.ONLINEORDER_PLAN*100).toFixed(2) }}%
                        </span>

                        <span v-else-if="data.ONLINEORDER/data.ONLINEORDER_PLAN >=0.50"
                          class="statusLabel-yellow">
                          {{ data.ONLINEORDER_PLAN  | formatNumberLocal}} : {{data.ONLINEORDER | formatNumberLocal}}  = {{ (data.ONLINEORDER/data.ONLINEORDER_PLAN*100).toFixed(2) }}%
                        </span>

                        <span v-else-if="data.ONLINEORDER/data.ONLINEORDER_PLAN >= 0.10"
                        class="statusLabel-organge">
                        {{ data.ONLINEORDER_PLAN  | formatNumberLocal}} : {{data.ONLINEORDER | formatNumberLocal}} = {{ (data.ONLINEORDER/data.ONLINEORDER_PLAN*100).toFixed(2) }}% 
                        </span>

                        <span v-else-if="data.ONLINEORDER/data.ONLINEORDER_PLAN >= 0"
                          class="statusLabel-black">
                          {{ data.ONLINEORDER_PLAN  | formatNumberLocal}} : {{data.ONLINEORDER | formatNumberLocal}} = {{ (data.ONLINEORDER/data.ONLINEORDER_PLAN*100).toFixed(2) }}% 
                        </span>
                      </td>
                      <td
                        class="has-text-centered"
                      >
                      <span v-if="data.ONLINEORDERMONEY/data.ONLINEORDERMONEY_PLAN >=1"
                          class="statusLabel-passed">
                          {{ data.ONLINEORDERMONEY_PLAN | formatNumberLocal }} : {{data.ONLINEORDERMONEY | formatNumberLocal}} = {{ (data.ONLINEORDERMONEY/data.ONLINEORDERMONEY_PLAN*100).toFixed(2) }}%
                        </span>

                        <span v-else-if="data.ONLINEORDERMONEY/data.ONLINEORDERMONEY_PLAN >=0.50"
                          class="statusLabel-yellow">
                          {{ data.ONLINEORDERMONEY_PLAN | formatNumberLocal }} : {{data.ONLINEORDERMONEY | formatNumberLocal}}  = {{ (data.ONLINEORDERMONEY/data.ONLINEORDERMONEY_PLAN*100).toFixed(2) }}%
                        </span>

                        <span v-else-if="data.ONLINEORDERMONEY/data.ONLINEORDERMONEY_PLAN >= 0.10"
                        class="statusLabel-organge">
                        {{ data.ONLINEORDERMONEY_PLAN | formatNumberLocal  }} : {{data.ONLINEORDERMONEY | formatNumberLocal}} = {{ (data.ONLINEORDERMONEY/data.ONLINEORDERMONEY_PLAN*100).toFixed(2) }}% 
                        </span>

                        <span v-else-if="data.ONLINEORDERMONEY/data.ONLINEORDERMONEY_PLAN >= 0"
                          class="statusLabel-black">
                          {{ data.ONLINEORDERMONEY_PLAN | formatNumberLocal }} : {{data.ONLINEORDERMONEY | formatNumberLocal}} = {{ (data.ONLINEORDERMONEY/data.ONLINEORDERMONEY_PLAN*100).toFixed(2) }}% 
                        </span>

                        

                        
                        
                      </td>
                    
              
                    </tr>
                  </tbody>
                </table>
              </b-field>
              

            </div>
          </div>
        
        </b-tab-item>
      </b-tabs>
    </div>

    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  data() {
    return {
      userName: null,
      roleid: null,
      activeTab: 1,
      
      reportDetailList: [],
      compareList:[],
      yearList: [],
      selectedYear: null,

      currentDate: null,
      currentYear: null,
      compareLabel: null,
    };
  },
  methods: {
    onSelectedYear(){
      this.currentYear = this.selectedYear.YEAR;
      this.getdasmReport();
      this.activeTab = 1;
    },
    getdasmReport(){

      if(this.currentYear== null){
        this.currentDate = new Date();
        this.currentYear = this.currentDate.getUTCFullYear();
      }

      this.compareLabel ="ລາຍງານ ທຽບໃສ່ ແຜນປະຈຳປີ "+this.currentYear;

      console.log("currentYear:" + this.currentYear)
        
        RestAPI.saleReport(this.currentYear, this.userBranchID)
        .then((res) => {
          this.reportDetailList = res.data.all;
          this.compareList = res.data.compare;
          this.yearList = res.data.year;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
   
      
    },




    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },



    clearPrintdata() {
      this.prepareidforprint = [];
      this.combineorderforprint = [];
      this.combineorderdetailforprint = [];
    },

    printReceipt(prepareid) {
      this.getMarketOnlineOrderDetailbyPrepareid(prepareid);
    },

    print() {
      window.print();
    },
  },
  mounted() {
    console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID
      ? this.user.BRANCHPROVNICEID
      : "all";
      this.userBranchID = this.user.DASMBRANCHID ?  this.user.DASMBRANCHID : 'all';
    this.getdasmReport();
    
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.very-important-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 40px;
}

/* .paymentdetailselected {
  margin-top: 5px;
  margin-bottom: 5px;
}
.paymentdetailselectedhightlight {
  font-weight: bold;
} */

.print-receipt {
  font-size: 10px;
}
.print-receipt-titel {
  font-size: 12px;
}
.print_table {
  font-size: 10px;
}
.print_tr {
  padding: 0px 0px 0px 0px;
}
.print_td {
  padding: 0px 0px 0px 0px !important;
  margin: 0px 0px 0px 0px !important;
  /* font-size: 20px; */
}
@media all {
  .page-break {
    display: none;
  }
}
@media print {
  @page {
    margin: -10px 0px 0px 0px !important;
    padding: -10px 0px 0px 0px !important;
    size: portrait;
  }
  .page-break {
    display: block;
    max-width: 99%;
  }
}
</style>
